import StartupPageTitle from '../../../components/StartupPageTitle';
import { Chats as PageHeadingIcon } from '@phosphor-icons/react';
import React, { useEffect, useState } from 'react';
import api from '@/api';
import { EnvelopeSimple, Handshake, TrendUp } from '@phosphor-icons/react';

const Interactions = () => {
  const [loading, setLoading] = useState(true);
  const [visibilityData, setVisibilityData] = useState(null);
  const [invites, setInvites] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const [visibilityRes, invitesRes] = await Promise.all([
          api.get('/startup/visibility'),
          api.get('/startup/invites'),
        ]);
        setVisibilityData(visibilityRes.data);
        setInvites(invitesRes.data || []);
      } catch (err) {
        console.error('Failed to load interaction data', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return <div className="p-6 text-center py-20 text-text-secondary">Loading...</div>;
  }

  const stats = visibilityData?.stats || {};
  const pendingInvites = invites.filter((invite) => invite.status === 'pending');
  const acceptedInvites = invites.filter((invite) => invite.status === 'accepted');

  return (
    <div className="p-4 sm:p-6">
      <div className="max-w-4xl mx-auto">
        <div className="startup-page-header mb-6">
          <StartupPageTitle icon={PageHeadingIcon} className="text-3xl font-heading font-bold text-text-primary mb-2" data-testid="interactions-heading">Interactions</StartupPageTitle>
          <p className="text-text-secondary text-[13px]">Track investor interest and your active FounderBoard connections.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-surface border border-border rounded-[10px] p-5" data-testid="stat-tracker-adds">
            <div className="flex items-center gap-2 mb-2">
              <TrendUp size={14} className="text-info" weight="bold" />
              <span className="text-[11px] uppercase tracking-wider text-text-muted">VCs Tracking You</span>
            </div>
            <div className="text-[28px] font-mono font-semibold text-text-primary">{stats.tracker_adds || 0}</div>
            <div className="mt-1 text-[11px] text-text-muted">Investors following your startup</div>
          </div>

          <div className="bg-surface border border-border rounded-[10px] p-5" data-testid="stat-portfolio-count">
            <div className="flex items-center gap-2 mb-2">
              <Handshake size={14} className="text-[#10b981]" weight="bold" />
              <span className="text-[11px] uppercase tracking-wider text-text-muted">Connected VCs</span>
            </div>
            <div className="text-[28px] font-mono font-semibold text-text-primary">{acceptedInvites.length}</div>
            <div className="mt-1 text-[11px] text-text-muted">Accepted portfolio connections</div>
          </div>

          <div className="bg-surface border border-border rounded-[10px] p-5" data-testid="stat-pending-invites">
            <div className="flex items-center gap-2 mb-2">
              <EnvelopeSimple size={14} className="text-warning" weight="bold" />
              <span className="text-[11px] uppercase tracking-wider text-text-muted">Pending Invites</span>
            </div>
            <div className="text-[28px] font-mono font-semibold text-text-primary">{pendingInvites.length}</div>
            <div className="mt-1 text-[11px] text-text-muted">Manage these from the Equity page</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Interactions;
